import React, { useState } from "react";
import Button from "@mui/material/Button";
import buttonStyles from "./../../styles/Atoms/Button/ButtonComponent";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function FileComponent({
  label,
  onClick,
  backgroundColor,
  color,
  setUrlFile = null,
  fileNameSet = null,
  setFile = null,
}) {
  const setNewFileName = (e) => {
    if (e.target?.files[0]) {
      if (typeof setFile === "function") {
        setFile(e?.target);
      }
      if (typeof setUrlFile === "function") {
        setUrlFile(e?.target.value);
      }
      if (typeof fileNameSet === "function") {
        fileNameSet(e?.target?.files[0].name || "");
      }

      e.target.value = null;
    }
  };

  return (
    <Button
      component="label"
      variant="contained"
      startIcon={<CloudUploadIcon />}
      sx={{
        ...buttonStyles.buttonStyle,
        backgroundColor: backgroundColor,
        color: color,
        "&:hover": {
          //you want this to be the same as the backgroundColor above
          backgroundColor: backgroundColor,
        },
      }}
    >
      {label}
      <input
        type="file"
        hidden
        onChange={setNewFileName}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
    </Button>
  );
}

export default FileComponent;
